import { NavLink } from "react-router-dom";
import logoCristinaNuovo from "../../assets/logoCristinaNuovo.jpeg";
import "./footer.css";
export const Footer = () => {
    return (
        <footer id="footer" className="bgBlue text-white">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="mt-3">
                            <p>Contattami senza impegno per qualsiasi informazione</p>

                            <p>
                                Mail:{" "}
                                <a target="_blank" className="text-white" href=" mailto: doulacri@gmail.com">
                                    doulacri@gmail.com
                                </a>
                            </p>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="mt-3">
                            <p className="">Attiva online e a Vigevano, Pavia, Voghera e paesi limitrofi</p>

                            <p>
                                Instagram:{" "}
                                <a
                                    target="_blank"
                                    className="text-white"
                                    href="https://www.instagram.com/custodiamoci_doula_cristina/"
                                >
                                    @custodiamoci_doula_cristina
                                </a>
                            </p>
                        </div>
                    </div>

                    <div className="align-self-center col-12 col-md-4 text-center">
                        <NavLink to="/" className="d-none d-lg-block">
                            <img className="logo-header" src={logoCristinaNuovo} alt="DoulaCristina" />
                        </NavLink>
                    </div>
                </div>
            </div>
        </footer>
    );
};
